import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Card,
  CardTitle,
  ContentMaxWidth,
  Muted,
  PageHeading,
  PageSubheading,
  Pill,
  Row,
  Stack,
} from '../../layout/styledComponents'

const sections = [
  { to: '/patient-home/records/prescriptions', icon: '📝', name: 'Prescriptions' },
  { to: '/patient-home/records/notes', icon: '🗒️', name: 'Notes shared with me' },
  { to: '/patient-home/records/shared', icon: '📤', name: 'Shared with me' },
  { to: '/patient-home/records/documents', icon: '📎', name: 'Documents' },
  { to: '/patient-home/records/receipts', icon: '🧾', name: 'Receipts & invoices' },
]

export default function RecordsIndexPage() {
  const navigate = useNavigate()
  return (
    <ContentMaxWidth>
      <Stack $gap="24px">
        <div>
          <Pill>Records</Pill>
          <PageHeading style={{ marginTop: 12 }}>Your records</PageHeading>
          <PageSubheading>
            Prescriptions, notes, uploaded documents, and receipts — print-ready when you need them.
          </PageSubheading>
        </div>
        <Stack $gap="12px">
          {sections.map((s) => (
            <Card
              key={s.to}
              as="button"
              onClick={() => navigate(s.to)}
              style={{ textAlign: 'left', cursor: 'pointer', fontFamily: 'inherit' }}
            >
              <Row $between>
                <Row $gap="14px">
                  <span style={{ fontSize: 24 }}>{s.icon}</span>
                  <CardTitle style={{ margin: 0 }}>{s.name}</CardTitle>
                </Row>
                <span aria-hidden style={{ color: '#6B7280', fontSize: 18 }}>›</span>
              </Row>
              <Muted style={{ marginTop: 8 }}>Tap to open.</Muted>
            </Card>
          ))}
        </Stack>
      </Stack>
    </ContentMaxWidth>
  )
}
